// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"e6efe7b4","239":"49fd22ee","732":"69bf7933"}[chunkId] + ".chunk.js";
};